export const state = {
    dollar: null,
    euro: null,
    pound: null,
};

export const mutations = {
    setDollar(state, data) {
        state.dollar = data
    },
    setEuro(state, data) {
        state.euro = data
    },
    setPound(state, data) {
        state.pound = data
    }
}

export const actions = {
    setDollar (context, value) {
        context.commit("setDollar", value)
    },
    setEuro (context, value) {
        context.commit("setEuro", value)
    },
    setPound (context, value) {
        context.commit("setPound", value)
    },
}